import type {
  AndamentoArbitralItem,
  AnexoUploadEnviado,
  VinculosEscritaInput,
} from '@/features/secretaria-arbitral/types';

export const ANEXOS_ESCRITA_MAX = 5;
export const BUSCA_ANDAMENTO_MIN = 2;

const ANDAMENTOS_SUGERIDOS_MAX = 8;
const RESUMO_ANDAMENTO_MAX = 140;

export function buscaAndamentoValida(termo: string): boolean {
  return termo.trim().length >= BUSCA_ANDAMENTO_MIN;
}

export function excedeLimiteDeAnexos(jaEnviados: number, novos: number): boolean {
  return jaEnviados + novos > ANEXOS_ESCRITA_MAX;
}

function rotuloTipoAndamento(tipo: string): string {
  return tipo.replaceAll('_', ' ').toLowerCase();
}

function dataAndamentoFormatada(andamento: AndamentoArbitralItem): string {
  return new Date(andamento.dataCriacao).toLocaleDateString('pt-BR');
}

export function rotuloAndamentoComData(andamento: AndamentoArbitralItem): string {
  return `${rotuloTipoAndamento(andamento.tipo)} · ${dataAndamentoFormatada(andamento)}`;
}

export function resumoDoAndamento(andamento: AndamentoArbitralItem): string {
  const texto = andamento.descricao.trim().replaceAll(/\s+/gu, ' ');
  if (texto.length <= RESUMO_ANDAMENTO_MAX) return texto;
  return `${texto.slice(0, RESUMO_ANDAMENTO_MAX)}…`;
}

export function filtrarAndamentosPorTermo(
  andamentos: AndamentoArbitralItem[],
  termo: string,
): AndamentoArbitralItem[] {
  if (!buscaAndamentoValida(termo)) return [];
  const alvo = termo.trim().toLowerCase();
  return andamentos
    .filter(
      (andamento) =>
        andamento.descricao.toLowerCase().includes(alvo) ||
        rotuloTipoAndamento(andamento.tipo).includes(alvo) ||
        dataAndamentoFormatada(andamento).includes(alvo),
    )
    .slice(0, ANDAMENTOS_SUGERIDOS_MAX);
}

export function montarVinculosEscrita(
  anexos: AnexoUploadEnviado[],
  andamentoVinculadoId: string | null,
): VinculosEscritaInput {
  const anexoUploadIds = anexos.slice(0, ANEXOS_ESCRITA_MAX).map((anexo) => anexo.uploadId);
  return {
    ...(anexoUploadIds.length > 0 ? { anexoUploadIds } : {}),
    ...(andamentoVinculadoId ? { andamentoVinculadoId } : {}),
  };
}

export function extrairUploadIdCriado(payload: unknown): string | null {
  if (typeof payload !== 'object' || payload === null) return null;
  const uploadId = (payload as Record<string, unknown>).uploadId;
  if (typeof uploadId !== 'string' || uploadId.length === 0) return null;
  return uploadId;
}
